module.exports = __webpack_public_path__ + "static/media/headerPhoto3.6ebbb1e8.jpg";